import { useOutsideClick } from '../../../hooks/useOutsideClick';
import { catalogMenu } from '../../slice/catalogMenu';
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MobileSearch from '../search/MobileSearch';
import Swiper, { Navigation } from 'swiper';

const Carousel = ({ name, brands, cId }) => {
  const id = `${name}-${cId}`;
  const idPrev = `${id}-prev`;
  const idNext = `${id}-next`;

  const breakpoints = {
    1700: {
      slidesPerView: 6,
      slidesPerGroup: 1,
    },
    1500: {
      slidesPerView: 5,
      slidesPerGroup: 1,
    },
    1420: {
      slidesPerView: 4,
      slidesPerGroup: 1,
    },
    1200: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
  };

  useEffect(() => {
    const swiper = new Swiper(`#${id}`, {
      modules: [Navigation],
      slidesPerView: 6,
      spaceBetween: 10,
      breakpoints: breakpoints,
      loop: false,
      navigation: {
        prevEl: `#${idPrev}`,
        nextEl: `#${idNext}`,
      },
    });

    return () => {
      swiper.destroy();
    };
  }, [breakpoints, idPrev, idNext]);

  if (brands.length === 0) {
    return <></>;
  }

  return (
    <>
      <div className="swiper cat-part__slid menu-swiper" id={id}>
        <div className="swiper-wrapper">
          {brands.map((brand) => {
            const { name, url, img, id } = brand;
            return (
              <div className="swiper-slide" key={`slide-${id}`}>
                <a href={`/brands/${url}`} className="cat-part__logo">
                  <img src={img} alt={name} />
                </a>
              </div>
            );
          })}
        </div>
      </div>
      <div
        id={idPrev}
        className="cat-part-prev swiper-button-prev menu-swiper"
      />
      <div
        id={idNext}
        className="cat-part-next swiper-button-next menu-swiper"
      />
    </>
  );
};

export const FirstLvlItem = ({ item, idx, hover }) => {
  const dispatch = useDispatch();
  const { name, img, href } = item;
  const [delay, setDelay] = useState(null);

  const onEnter = () => {
    setDelay(
      setTimeout(() => {
        hover(idx);
      }, 200),
    );
  };

  const onLeave = () => {
    clearTimeout(delay);
  };

  const enableSubMenu = (evt) => {
    dispatch(catalogMenu.actions.enableSubMenu(idx));
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  return (
    <>
      <a
        href={href}
        className="desktop-only"
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
      >
        <div className="menu__icon">
          {img !== '' && <img src={img} alt={name} />}
        </div>
        <span>{name}</span>
      </a>
      <a href="#" className="mobile-only" onClick={enableSubMenu}>
        <div className="menu__icon">
          {img !== '' && <img src={img} alt={name} />}
        </div>
        <span>{name}</span>
      </a>
    </>
  );
};

export const SubMenu = ({ item, visible, brands }) => {
  const dispatch = useDispatch();
  const { id, name, items } = item;

  let className = 'cat-menu__box';
  if (visible) {
    className += ' active';
  }

  const resetSubMenu = () => dispatch(catalogMenu.actions.resetSubMenu());

  return (
    <div className={className}>
      <div className="for-back-block">
        <div className="go-back__menu" onClick={resetSubMenu} />
        <h3>{name}</h3>
        <div className="go-back__menu close__cirp" onClick={resetSubMenu}>
          <img src="/static/img/close.svg" alt="icon" />
        </div>
      </div>
      <div className="cat-menu__block">
        <div className="cat-menu__fl">
          <div className="cat-menu__info">
            <div className="cat-menu__href">
              <ul>
                {items.map(({ name, href }, idx) => {
                  return (
                    <li key={`l2_sub_${idx}`}>
                      <a href={href}>{name}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
        {brands.length > 0 && (
          <div className="cat-menu__part">
            <Carousel name="brands" cId={id} brands={brands} />
          </div>
        )}
      </div>
    </div>
  );
};

export const Menu = ({ items, brands }) => {
  const dispatch = useDispatch();
  const { visible, subMenu } = useSelector((state) => state.catalogMenu);
  const [curr, setCurr] = useState(0);
  const ref = useRef(null);

  const hide = () => dispatch(catalogMenu.actions.hide());
  useOutsideClick(ref, hide);

  let className = 'min-block-catalog';
  if (visible) {
    className += ' catalog-menu__active';
  }

  return (
    <div className={className} ref={ref}>
      <div className="block-catalog__close" onClick={hide}>
        <img src="/static/img/close.svg" alt="icon" />
      </div>
      <div className="cat-menu__cnt">
        <div className="block-inp__mov app-search__in_modal">
          <MobileSearch id="in-menu-typeahead" />
        </div>

        <ul>
          {items.map((item, idx) => {
            const { id } = item;
            const mobileActive = idx === subMenu ? 'cat-menu__sub' : '';
            const menuBrands = brands && id in brands ? brands[id] : [];
            return (
              <li key={`cm-${id}`} className={mobileActive}>
                <FirstLvlItem item={item} idx={idx} hover={setCurr} />
                <SubMenu
                  item={item}
                  visible={idx === curr}
                  brands={menuBrands}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
